import { render } from "./ClassificationListView.vue?vue&type=template&id=3aef3975&scoped=true&ts=true"
import script from "./ClassificationListView.vue?vue&type=script&lang=ts"
export * from "./ClassificationListView.vue?vue&type=script&lang=ts"

import "./ClassificationListView.vue?vue&type=style&index=0&id=3aef3975&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aef3975"]])

export default __exports__